export const PREFIX = 'SelectedSegmentItem';

export const classes = {
  iconContainer: `${PREFIX}-iconContainer`,
};
